<template>
  <el-card v-loading="loading">
    {{ info }}
  </el-card>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'idcheckInfo',
  data: () => ({
    info: '',
    loading: true
  }),
  created() {
    apiRes.get(apiRes.idcheckInfo).then((data) => {
      this.loading = false
      this.info = data.page_vars.res
    })
  }
}
</script>
